import moment from "moment";

export const GetLocaleDate = (date?: string, hideHour?: boolean) =>
  date
    ? moment(new Date(date + "+00:00")).format(
        hideHour ? "DD/MM/yyyy" : "DD/MM/yyyy HH:mm"
      )
    : "-";
